import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const FormModalWrapper = styled(Modal)`
  /*
    The modal body holds the whole Forms page, which starts out empty while its
    list request is in flight. Without a floor the body collapsed to the height
    of the toolbar alone, so opening the modal showed a header strip over blank
    space with the footer jammed up underneath it.
  */
  .ant-modal-body {
    min-height: 420px;
  }

  /*
    globalStyle gives .cancel-button width: 50%, which is right for the usual
    Cancel + Save footer pair. This modal has no Save — it is a browse-and-close
    view — so a lone 50%-wide grey slab is the wrong shape. Right-align it and
    let it size to its label like any other single dismiss button.
  */
  .ant-modal-footer {
    justify-content: flex-end;
  }

  .ant-modal-content .ant-modal-footer .cancel-button {
    min-width: 120px;
    width: auto;
    padding: 8px 24px;
  }
`;

export default WithDirection(FormModalWrapper);
